import cn from "classnames";
import { paths } from "helpers/paths";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import CommonReport from "./commonReport";

export default class CitiesReport extends CommonReport {
    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            Aggregated: ({ row: { subRows, depth } }) => (
                <strong>{formatValue(this.aggregatedValue(subRows, depth, columnName(column)), column.clrType)}</strong>
            ),
            Cell: (props) => {
                const {
                    row,
                    column: tableColumn,
                    value,
                    row: { original, values },
                } = props;
                const uniqueId = { [`data-${tableColumn.id}`.toLowerCase()]: values.city };
                if (tableColumn.id === "state") {
                    return value || "";
                }
                if (tableColumn.id === "city") {
                    if (original?.nextCitiesData?.length) {
                        const onClick = () => {
                            props.modal({
                                name: "infoModal",
                                windowMod: "wide",
                                title: value,
                                body: props.renderRowSubComponent(props.row),
                            });
                        };
                        return (
                            <div className="cursor-pointer long-text" onClick={onClick}>
                                <i
                                    className={cn("r-item__expander", {
                                        "icon-uEAAE-angle-right-solid": !row.isExpanded,
                                        "icon-uEA61-angle-down": row.isExpanded,
                                    })}
                                />
                                <span {...uniqueId}>{value}</span>
                            </div>
                        );
                    } else {
                        return (
                            <div {...uniqueId} className="long-text">
                                {value}
                            </div>
                        );
                    }
                } else {
                    return (
                        <div {...uniqueId} className="long-text">
                            {formatValue(value, column.clrType)}
                        </div>
                    );
                }
            },
            ...typeSpecificProps(column),
        };
    };

    extractColumns = () => {
        const { columns } = this.props.data || {};
        return columns.filter((item) => !!item.label).map(this.cellProps);
    };

    aggregatedValue = (subRows, _level, columnName) => {
        if (columnName === "city") {
            return "";
        }
        return subRows[0].original.stateData?.[columnName] || "";
    };

    tableExtraProps = () => ({
        initialState: this.props.groupByRegion ? { groupBy: ["state"] } : {},
        renderRowSubComponent: (row, isPrintForm) => {
            if (row.original.nextCitiesData.length === 0) {
                return null;
            }
            const tableProps = isPrintForm
                ? {
                      className: "p-3 reports--bg-bluelight",
                      style: { minWidth: "100%", width: row.cells.reduce((acc, cell) => acc + cell.column.width, 0) },
                  }
                : {
                      className: "table-responsive",
                  };
            return (
                <div {...tableProps}>
                    <table className="table table-sm mb-0 border-bottom border-secondary bg-secondary">
                        <thead>
                            <tr className="table-active">
                                <th>#</th>
                                <th>Город загрузки</th>
                                <th>Заявка</th>
                                <th>Внешний ID Заявки</th>
                                <th>Порожний пробег до загрузки, км</th>
                            </tr>
                        </thead>
                        <tbody>
                            {row.original.nextCitiesData.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td data-city>{item.city}</td>
                                    <td data-bidid={item.city}>
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={paths.bidShow("bid", item.bidId)}
                                        >
                                            {item.bidId}
                                        </a>
                                    </td>
                                    <td data-externalId>{item.externalId}</td>
                                    <td data-emptymileage={item.city}>{formatValue(item.emptyMileage, "double")}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        },
    });
}
